import { logger } from 'src/app/common/services/logging/logging.service';
import { SpeechRecognition } from '@capacitor-community/speech-recognition';
import { VoiceRecognitionService } from './voice-recognition.service';

export class VoiceRecognitionAppService extends VoiceRecognitionService {

  constructor() {
    super();

    SpeechRecognition.available().then(available => {
      if (available.available) {
        SpeechRecognition.checkPermissions().then(permStatus => {
          if (permStatus.speechRecognition === 'prompt' || permStatus.speechRecognition === 'prompt-with-rationale') {
            SpeechRecognition.requestPermissions().then(isAllowed => {
              this.isDeviceSupport$.next(isAllowed.speechRecognition === 'granted');
              this.isDeviceSupport$.complete();
            });
          }
          else {
            // Exist permissions status
            this.isDeviceSupport$.next(permStatus.speechRecognition === 'granted');
            this.isDeviceSupport$.complete();
          }
        });
      }
      else {
        // Not available
        this.isDeviceSupport$.next(false);
        this.isDeviceSupport$.complete();
      }
    });
  }


  public init() {
    SpeechRecognition.addListener("partialResults", (data: any) => {
      logger.debug("partialResults was fired", data.matches);
      if (data.matches && data.matches.length > 0) {
        this.message$.next(data.matches[0]);
        this.updateSilentTimer();
      }
    });

    logger.debug("VoiceRecognitionAppService initialized");
  }

  override async start() {
    if ((this.isListening$.value)) {
      logger.error("Start was called but it is already listening");
      return;
    }
    
    // await this.playAudio();

    this.message$.next("");
    this.isListening$.next(true);

    SpeechRecognition.start({
      language: "en-US",
      maxResults: 1,
      partialResults: true,
    }).then(() => {
      logger.debug("SpeechRecognition started");
    }).catch((error) => {
      logger.error("SpeechRecognition start failed", error);
      this.isListening$.next(false);
      this.isCompleted$.next(true);
      this.isCompleted$.complete();
    });

  }

  override stop() {
    if (!(this.isListening$.value)) {
      logger.error("Stop was called while it is not listening");
      return;
    }

    SpeechRecognition.stop();

    this.isListening$.next(false);
    this.isCompleted$.next(true);
    this.isCompleted$.complete();
  }

}
